//@helpers
const CurrencyHelper = require('utilities/currencyHelper');

// @constants
const {
    MYPROFILE_BROKER_LESS_THAN_ONE,
    PERCENTAGE_SYMBOL,
} = require('constants/index');

const formatPercentage = (
    percentage = 0,
    showSymbol = true,
    aproximateOneHundred = true,
) => {
    let amount = Math.round(percentage * 100);

    if (!aproximateOneHundred && amount === 100 && percentage !== 1) {
        amount = 99;
    }

    if (showSymbol) {
        amount += PERCENTAGE_SYMBOL;
    }

    return amount;
};

const getAssetIdsToIncreaseByOne = (immAssetAllocations, hasAnyData) => {
    let integerSum = 0;
    let hasLessThanOne = false;
    if (hasAnyData) {
        immAssetAllocations.forEach(immElem => {
            const integerPart = Math.floor(immElem.get('weight') * 100);
            integerSum += integerPart;
            if (
                immElem.get('weight') > 0 &&
                integerPart === 0 &&
                Math.round(immElem.get('weight') * 100) === 0
            ) {
                hasLessThanOne = true;
            }
        });
        const toIncrease = hasLessThanOne
            ? 100 - integerSum - 1
            : 100 - integerSum;

        const roundUpWeights = immAssetAllocations.sort(
            (immElem1, immElem2) => {
                const weight1IntegerPart = Math.floor(
                    immElem1.get('weight') * 100,
                );
                const weight2IntegerPart = Math.floor(
                    immElem2.get('weight') * 100,
                );
                const weight1DecimalPart =
                    Math.round(
                        (immElem1.get('weight') * 100 - weight1IntegerPart) *
                            100,
                    ) / 100;
                const weight2DecimalPart =
                    Math.round(
                        (immElem2.get('weight') * 100 - weight2IntegerPart) *
                            100,
                    ) / 100;
                return weight2DecimalPart - weight1DecimalPart;
            },
        );

        const idsOrdenedByDecimalWeight = roundUpWeights.map(immElem => {
            return immElem.get('assetClassId');
        });

        return idsOrdenedByDecimalWeight.toJS().slice(0, toIncrease);
    } else return [];
};

const formatPercentageWithLessOne = (
    value = 0,
    fixMissingOnePercent = false,
) => {
    let truncatedValue;
    const percentage = value * 100;

    if (percentage > 0 && percentage < 1 && !fixMissingOnePercent) {
        truncatedValue = MYPROFILE_BROKER_LESS_THAN_ONE;
    } else {
        truncatedValue = Math.floor(percentage);
    }

    return percentage != 100 && fixMissingOnePercent
        ? truncatedValue + 1
        : truncatedValue;
};

const formatWithoutRoundedPercentage = (percentage = 0, showSymbol = true) => {
    let amount = percentage * 100;

    if (showSymbol) {
        amount += PERCENTAGE_SYMBOL;
    }

    if (Math.abs(amount) < 0.005) return 0;

    return amount;
};

const formatPercentageWithDecimals = (percentage = 0, showSymbol = true) => {
    let amount = CurrencyHelper.formatAmount(percentage * 100, null, 2);

    if (showSymbol) {
        amount += ' ' + PERCENTAGE_SYMBOL;
    }

    if (Math.abs(amount) < 0.005) return 0;

    return amount;
};

module.exports = {
    getAssetIdsToIncreaseByOne,
    formatPercentage,
    formatPercentageWithLessOne,
    formatWithoutRoundedPercentage,
    formatPercentageWithDecimals,
};
